import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const BannerWrapper = styled.div`
  width: calc(100vw - 27rem);
  padding: 0 4.2rem;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

const BannerContainer = styled.div`
  width: 100%;
  max-width: 130rem;
  padding: 1.5rem 2rem;
  flex-shrink: 0;
  background: linear-gradient(90deg, #e8f4fd 0%, #f0e8fd 100%);
  border: 1px solid #c4d9f2;
  border-radius: 1rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
  gap: 12px;
`;

const StyledTitle = styled.span`
  color: #1a3d5c;
  font-size: 1.4rem;
  font-style: normal;
  font-weight: 600;
  line-height: 1.375rem;
  display: flex;
  align-items: center;
  gap: 6px;
`;

const StyledSubTitle = styled.span`
  color: #1a3d5c;
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.25rem;
  margin-top: 4px;
`;

const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const IconSection = styled.span`
  font-size: 1.6rem;
`;

const AnnouncementBanner = ({ title, subtitle }) => {
    return (
      <BannerWrapper>
        <BannerContainer>
          <ContentSection>
            <StyledTitle>
              {title}
              <IconSection>✨</IconSection>
            </StyledTitle>
            {subtitle && <StyledSubTitle>{subtitle}</StyledSubTitle>}
          </ContentSection>
        </BannerContainer>
      </BannerWrapper>
    );
};

AnnouncementBanner.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
};

AnnouncementBanner.defaultProps = {
    subtitle: '',
};

export default AnnouncementBanner;
